import { PAYER_USER_STATUS_ACTIVE } from 'consts';

const isActive = (payerUser) => payerUser?.status === PAYER_USER_STATUS_ACTIVE;

const resolveEnrolledViewAsIdentity = ({ payerId, payerUser, payerUsers }) => {
  if (payerUser) {
    return isActive(payerUser) ? { payerId, userId: payerUser.userId } : null;
  }
  const active = (payerUsers ?? []).filter(isActive);
  return active.length === 1 ? { payerId, userId: active[0].userId } : null;
};

export default resolveEnrolledViewAsIdentity;
